document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var mainForm = document.querySelector('form[action^="/cart/add"]');
  if (!mainForm) return;

  var mainSubmit = mainForm.querySelector('button[type="submit"]');
  if (!mainSubmit) return;

  var trigger = bar.querySelector('[data-sticky-atc-button]');
  if (trigger) {
    trigger.addEventListener('click', function () {
      mainSubmit.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    });
  });

  observer.observe(mainSubmit);
});
